import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import { useProfile } from '../hooks/useProfile';
import type { PrivacyLevel, ProfileVisibility } from '../types';

export function PrivacySettings() {
  const { profile, updateProfile, isLoading } = useProfile(null);
  const [defaultPrivacy, setDefaultPrivacy] = useState<PrivacyLevel>(
    profile?.defaultPrivacy || 'public'
  );
  const [profileVisibility, setProfileVisibility] = useState<ProfileVisibility>(
    profile?.profileVisibility || 'public'
  );
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSave = async () => {
    setSuccess(false);
    setError(null);
    try {
      await updateProfile({ defaultPrivacy, profileVisibility });
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Falha ao salvar configuracoes');
    }
  };

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess(false)}>
          Configuracoes de privacidade salvas.
        </Alert>
      )}

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Privacidade Padrao de Trips
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Define a privacidade padrão para novas viagens criadas.
          </Typography>
          <FormControl fullWidth sx={{ maxWidth: 300 }}>
            <InputLabel id="default-privacy-label">Privacidade padrão</InputLabel>
            <Select
              labelId="default-privacy-label"
              value={defaultPrivacy}
              label="Privacidade padrão"
              onChange={(e) => setDefaultPrivacy(e.target.value as PrivacyLevel)}
            >
              <MenuItem value="public">Publico - Visivel para todos</MenuItem>
              <MenuItem value="friends">Amigos - Apenas seguidores</MenuItem>
              <MenuItem value="private">Privado - Apenas voce</MenuItem>
            </Select>
          </FormControl>
        </CardContent>
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Visibilidade do Perfil
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Controla quem pode ver seu perfil e estatísticas.
          </Typography>
          <FormControl fullWidth sx={{ maxWidth: 300 }}>
            <InputLabel id="profile-visibility-label">Visibilidade</InputLabel>
            <Select
              labelId="profile-visibility-label"
              value={profileVisibility}
              label="Visibilidade"
              onChange={(e) => setProfileVisibility(e.target.value as ProfileVisibility)}
            >
              <MenuItem value="public">Publico</MenuItem>
              <MenuItem value="private">Privado</MenuItem>
            </Select>
          </FormControl>
        </CardContent>
      </Card>

      <Button
        variant="contained"
        onClick={handleSave}
        disabled={isLoading}
        startIcon={isLoading ? <CircularProgress size={16} /> : undefined}
      >
        Salvar configuracoes
      </Button>
    </Box>
  );
}
